import React, { Fragment, useState } from 'react'
import { formatDbDate } from '../../../utils/dateFormater';
import { cancelInvitationAction } from '../../../redux/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../loader/loader';
import HoverFullText from '../../../elements/HoverToolKit';
const SingleAdmin = ({ invite, index, totalinvites }) => {



    const [showPopup, setShowPopup] = useState(false);
    const [actionToPerform, setActionToPerform] = useState("");
    const [popupHeading, setPopupHeading] = useState("");
    const [popupPara, setPopupPara] = useState("");



    const dispatch = useDispatch()

    const { loading } = useSelector(state => state.inviteUser)


    const displayIndex = String(totalinvites - index).padStart(2, '0');



    const handleUpdateStatus = (userId, UserStatus) => {

        let data = {
            invitation_id: invite.id,
        }

        dispatch(cancelInvitationAction(data));

    }



    const getInviteStatus = (status, expires_at) => {
        // 1️⃣ If cancelled → always return CANCELLED

        if (invite?.used_at) return "COMPLETED"
        if (status === "CANCELLED") {
            return "CANCELLED";
        }

        // 2️⃣ Parse dates safely
        const now = new Date();
        const expiry = new Date(expires_at);

        // 3️⃣ Compare time
        if (now < expiry) {
            return status;
        }

        // 4️⃣ Expired case
        return "EXPIRED";
    };


    const handleClassName = (orderStatus) => {


        if (orderStatus === "ACTIVE") return "text-green-600 bg-green-100";
        if (orderStatus === "CANCELLED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "EXPIRED") return "text-red-500 bg-red-100";
        if (orderStatus === "COMPLETED") return "text-blue-500 bg-blue-100";

    }






    return (
        <Fragment>
            {loading && <Loader />}
            <div className="border-b border-gray-100 last:border-b-0 hover:bg-gray-50/50 transition-colors relative" >
                {Number(invite?.active_reports_count) > 0 &&
                    <div className={`absolute top-0 left-0 text-[0.75vmax] font-jakarta font-bold p-[0.2vmax_0.8vmax] 
                        ${Number(invite?.active_reports_count) > 20 ? "bg-red-500" : 
                          Number(invite?.active_reports_count) > 10 ? "bg-orange-400" : "bg-emerald-500"} 
                        text-white rounded-br-lg z-10`}
                    >
                        {invite?.active_reports_count} Active Report(s)
                    </div>
                }
                
                {/* Top Section: Details (Grid) */}
                <div 
                    className="grid py-[1.2vmax] items-center"
                    style={{ gridTemplateColumns: 'minmax(0, 0.5fr) minmax(0, 2fr) minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(0, 1fr)' }}
                >
                    <div className="text-center text-zinc-400 font-jakarta font-bold text-[0.9vmax]" >
                        {displayIndex}
                    </div>
                    <div className="px-[1vmax] flex gap-[1vmax] items-center" >
                        <span className="text-zinc-700 font-jakarta font-medium text-[0.85vmax] lowercase" >
                            <HoverFullText text={invite?.email} sliceLength={20} />
                        </span>
                    </div>

                    <div className="text-center" >
                        <span className={`px-[0.8vmax] py-[0.2vmax] rounded-full text-[0.75vmax] font-jakarta font-bold uppercase tracking-wider bg-zinc-100 text-zinc-600`}>
                            {invite?.role || "N/A"}
                        </span>
                    </div>

                    <div className="text-center text-zinc-700 font-jakarta font-bold text-[0.85vmax]" >
                        {invite?.admin_name ?
                            <HoverFullText text={invite?.admin_name} sliceLength={16} />
                            : "N/A"
                        }
                    </div>

                    <div className="text-center text-zinc-500 font-jakarta text-[0.8vmax]" >
                        {formatDbDate(invite?.created_at)}
                    </div>

                    <div className="text-center text-zinc-500 font-jakarta text-[0.8vmax]" >
                        {formatDbDate(invite?.expires_at)}
                    </div>

                    <div className="text-center" >
                        <span className={`px-[0.8vmax] py-[0.2vmax] rounded-full text-[0.75vmax] font-jakarta font-bold uppercase tracking-wider ${handleClassName(getInviteStatus(invite?.status, invite?.expires_at))}`}>
                            {getInviteStatus(invite?.status, invite?.expires_at)}
                        </span>
                    </div>
                </div>

                {/* Bottom Section: Actions & Info */}
                <div className={`flex ${invite?.used_at ? "justify-between" : "justify-end"} items-center bg-zinc-50 p-[0.8vmax_1.5vmax] border-t border-zinc-100`}>
                    {invite?.used_at &&
                        <div className="text-[0.8vmax] text-zinc-600 font-jakarta flex items-center gap-1">
                            <span className="font-bold text-emerald-600 flex items-center gap-1">
                                <i className="fa-solid fa-circle-check"></i> Used At:
                            </span>
                            <span className="font-medium text-zinc-700">{formatDbDate(invite?.used_at)}</span>
                        </div>
                    }
                    
                    <div className="flex justify-end gap-2">
                        <button 
                            className={`px-4 py-1.5 rounded-lg text-[0.8vmax] font-jakarta font-bold transition-all text-white bg-gradient-to-r from-red-500 to-red-600 hover:shadow-md active:scale-[0.98] ${getInviteStatus(invite?.status, invite?.expires_at) !== "ACTIVE" || invite?.used_at !== null ? "opacity-50 cursor-not-allowed" : ""}`}
                            disabled={getInviteStatus(invite?.status, invite?.expires_at) !== "ACTIVE" || invite?.used_at !== null}
                            onClick={() => {
                                setShowPopup(true)
                                setActionToPerform("BLOCKED")
                                setPopupHeading(`Cancel Invite`)
                                setPopupPara(`Are you sure you want to cancel this invite?`)
                            }}
                        >
                            Cancel Invite
                        </button>
                    </div>
                </div>
            </div>
            {showPopup && (
                <div className="fixed inset-0 flex-center bg-zinc-900/50 backdrop-blur-sm z-[99999999999] p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-zinc-100 transform transition-all p-6">
                        
                        {/* Icon */}
                        <div className="mx-auto w-12 h-12 rounded-full bg-red-50 text-red-600 flex-center text-2xl mb-4">
                            <i className="fa-solid fa-triangle-exclamation"></i>
                        </div>

                        {/* Content */}
                        <div className="text-center">
                            <h3 className="font-bold text-lg text-zinc-800 font-jakarta mb-2">
                                {popupHeading}
                            </h3>
                            <p className="text-sm text-zinc-500 leading-relaxed">
                                {popupPara}
                            </p>
                        </div>

                        {/* Buttons */}
                        <div className="flex gap-3 mt-6">
                            <button
                                className="flex-1 text-zinc-600 font-jakarta font-semibold py-2.5 px-4 rounded-xl border border-zinc-200 hover:bg-zinc-50 transition-all active:scale-[0.98]"
                                onClick={() => {
                                    setShowPopup(false)
                                    setActionToPerform("")
                                    setPopupHeading("")
                                    setPopupPara("")
                                }}
                            >
                                No, Cancel
                            </button>
                            <button
                                className="flex-1 bg-gradient-to-r from-red-600 to-red-700 text-white font-jakarta font-semibold py-2.5 px-4 rounded-xl hover:shadow-lg hover:shadow-red-100 transition-all active:scale-[0.98]"
                                onClick={() => handleUpdateStatus(invite?.id, actionToPerform)}
                            >
                                Yes Proceed
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    )
}

export default SingleAdmin